export { default as onFeatureFlagUpdate } from './update';
